module.exports = __webpack_public_path__ + "media/alarm.d58eef13.mp3";